import { render, staticRenderFns } from "./AttoreQualifications.vue?vue&type=template&id=3608d58f&"
import script from "./AttoreQualifications.vue?vue&type=script&lang=ts&"
export * from "./AttoreQualifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports